import AppGeoportal from './App'
import AppHeader from 'components/AppHeader'
import AppFooter from 'components/AppFooter'
import AuthPanel from 'components/AuthPanel'
import GeoportalMap from 'components/GeoportalMap'
import GiscubeLayout from 'layouts/GiscubeLayout'
import CatalogPanel from 'components/CatalogPanel'
import CatalogTreePanel from 'components/CatalogTreePanel'
import CatalogResult from 'components/CatalogResult'
import CoordsPanel from 'components/CoordsPanel'
import CopyToClipboard from 'components/CopyToClipboard'
import DataPanel from 'components/data-layer/DataPanel'
import DataRow from 'components/DataRow'
import DataRowToggle from 'components/DataRowToggle'
import Sidebar from 'components/Sidebar'
import DrawPanel from 'components/DrawPanel'
import FileSelect from 'components/FileSelect'
import IncidencePanel from 'components/IncidencePanel'
import AggregationTable from 'components/statistics/AggregationTable'
import PaletteSelect from 'components/statistics/PaletteSelect'
import PolygonTooltip from 'components/statistics/PolygonTooltip'
import PlacePanel from 'components/PlacePanel'
import PlacePanelStrategy from 'components/PlacePanelStrategy'
import SearchBar from 'components/SearchBar'
import SearchPanel from 'components/SearchPanel'
import SharePanel from 'components/SharePanel'
import ShareQuery from 'src/lib/shareQuery'
import QueryOnClick from 'components/QueryOnClick'
import LayersControl from 'components/LayersControl'
import HelpPanel from 'components/HelpPanel'
import StreetViewPanel from 'components/StreetViewPanel'
import api from './api'
import geoportalBoot from './boot'
import store from './store/index.js'
import config from './config/lib.js'
import { except as exceptLib } from './lib/except.js'
import i18n from './i18n/index.js'
import Search from './lib/search'

const boot = geoportalBoot.setup

// Importacions generiques
import lib from './lib/'
import components from './components'

export {
  AppGeoportal,
  AppHeader,
  AppFooter,
  AuthPanel,
  CatalogPanel,
  CatalogTreePanel,
  CatalogResult,
  CoordsPanel,
  CopyToClipboard,
  DataPanel,
  DataRow,
  DataRowToggle,
  GeoportalMap,
  GiscubeLayout,
  Sidebar,
  DrawPanel,
  FileSelect,
  IncidencePanel,
  PaletteSelect,
  PolygonTooltip,
  AggregationTable,
  PlacePanel,
  PlacePanelStrategy,
  SearchBar,
  SearchPanel,
  SharePanel,
  ShareQuery,
  QueryOnClick,
  LayersControl,
  HelpPanel,
  StreetViewPanel,
  api,
  boot,
  store,
  config,
  exceptLib,
  i18n,
  Search,
  components,
  lib
}
